// src/App.tsx
import React, { useContext } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { CustomizationsContext, CustomizationHelmet, ErrorBoundary } from "@personicom/customizations";
import AppHeader from "./app-header";
import AppBody from "./app-body";
import AppDrawer from "./app-drawer";
import { AppStateProvider } from "app-state";
import LoadingIndicator from "components/loading-indicator";

const GA_TRACKER = "UA-102377011-8";
const GA_TRACKER_SECONDARY = "UA-157273197-1"; // Fallback

const App: React.FC = () => {
  const { isInitialized } = useContext(CustomizationsContext);
  if (!isInitialized) {
    return <LoadingIndicator />;
  }

  return (
    <Router>
      <AppStateProvider>
        <CustomizationHelmet gaTrackerId={GA_TRACKER} gaTrackerSecondaryId={GA_TRACKER_SECONDARY} />
        <ErrorBoundary>
          <AppHeader />
          <AppBody />
          <AppDrawer />
        </ErrorBoundary>
      </AppStateProvider>
    </Router>
  );
};

export default App;